<template>
  <base-content>
    <base-loader>
      Updating...
    </base-loader>
  </base-content>
</template>

<script>
export default {
  async created () {
    await this.$store.dispatch('core/auth/sync')
    this.$router.push({ name: 'dashboard' })
  }
}
</script>
